import * as React from "react"
import { ImageTextStyles } from "./ImageTextStyles"
import MenuButton from "./../Button/button"
import Menu from "./../../../static/Menu.pdf"

const ImageTextModule = ({ title, content, menu, image, about }) => {
  return (
    <ImageTextStyles about={about} className="section">
      <div id="about" className="container">
        <div className="text">
          <div className="title">
            {title}
            <span style={{ color: "#f8b3ad" }}>.</span>
          </div>
          <div className="line"></div>
          <div className="content">
            {content}
            {menu ? <MenuButton href={Menu} text="Menu" /> : null}
          </div>
        </div>
        <div className="image">
          <img src={image} alt="cake" />
        </div>
      </div>
    </ImageTextStyles>
  )
}

export default ImageTextModule
